import { Component, Prop } from 'vue-property-decorator'
import ClvrComponent from '../../../../../../system/vue/Core/ClvrComponent'
import { KhText } from '@internal-libraries/kheops-ui-lib'
import CommonHelper from '../../../../../../system/vue/Classes/CommonHelper'

@Component({
    components: {
        KhText,
    },
})
export default class ClvrScreenControlInterventionScheduleCell extends ClvrComponent {
    @Prop({ type: String, default: '' })
    public start!: string

    @Prop({ type: String, default: '' })
    public end!: string

    public get startOperation(): string {
        return CommonHelper.convertTimeToHourMinute(this.start)
    }

    public get endOperation(): string {
        return CommonHelper.convertTimeToHourMinute(this.end)
    }
}
